import React, { useState } from "react";
import {
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBBtn,
  MDBIcon,
  MDBBadge,
  MDBTooltip,
  MDBPagination,
  MDBPaginationItem,
  MDBPaginationLink
} from "mdb-react-ui-kit";

const MessageTableView = ({
  messages,
  currentPage,
  totalPages,
  onEdit,
  onDelete,
  onPageChange,
  onAddMessage
}) => {
  const [expandedMessages, setExpandedMessages] = useState({});

  const toggleMessage = (messageId) => {
    setExpandedMessages(prev => ({
      ...prev,
      [messageId]: !prev[messageId]
    }));
  };

  const getStatusBadge = (status) => {
    let color;
    switch (status) {
      case 'present':
        color = 'success';
        break;
      case 'future':
        color = 'primary';
        break;
      case 'past':
        color = 'warning';
        break;
      default:
        color = 'info';
    }
    return (
      // <MDBTooltip tag='span' title={`Message is ${status}`}>
        <MDBBadge color={color} className="text-capitalize">
          {status}
        </MDBBadge>
      // </MDBTooltip>
    );
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <MDBPaginationItem key={i} active={i === currentPage}>
          <MDBPaginationLink onClick={() => onPageChange(i)}>
            {i}
          </MDBPaginationLink>
        </MDBPaginationItem>
      );
    }

    return (
      <div className="d-flex justify-content-center mt-4">
        <MDBPagination>
          <MDBPaginationItem disabled={currentPage === 1}>
            <MDBPaginationLink onClick={() => onPageChange(currentPage - 1)}>
              Previous
            </MDBPaginationLink>
          </MDBPaginationItem>
          {pages}
          <MDBPaginationItem disabled={currentPage === totalPages}>
            <MDBPaginationLink onClick={() => onPageChange(currentPage + 1)}>
              Next
            </MDBPaginationLink>
          </MDBPaginationItem>
        </MDBPagination>
      </div>
    );
  };

  const renderEmptyState = () => (
    <div className="text-center py-4">
      <MDBIcon icon="comment-slash" size="3x" className="text-muted mb-3" />
      <p className="text-muted">No messages found</p>
      <MDBBtn color="primary" onClick={onAddMessage}>
        Create your first message
      </MDBBtn>
    </div>
  );

  const renderContent = (message) => {
    const isExpanded = expandedMessages[message.id];
    const content = message.content;
    const plainText = content.replace(/<[^>]*>/g, '');
    
    return (
      <div className="message-content">
        {/* <MDBTooltip
          tag='span'
          wrapperClass="d-inline-block"
          title={<div dangerouslySetInnerHTML={{ __html: content }} />}
          wrapperProps={{ style: { cursor: 'pointer', maxWidth: '100%' } }}
        > */}
          <div className="text-truncate" style={{ maxWidth: '300px' }}>
            {plainText.substring(0, 100)}
            {plainText.length > 100 && '...'}
          </div>
        {/* </MDBTooltip> */}
        {plainText.length > 100 && (
          <MDBBtn 
            color="link" 
            size="sm" 
            className="p-0 ms-2"
            onClick={() => toggleMessage(message.id)}
          >
            {isExpanded ? 'Show Less' : 'Show More'}
          </MDBBtn>
        )}
        {isExpanded && (
          <div 
            className="mt-2 border-start ps-3"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
    );
  };

  if (messages.length === 0) {
    return renderEmptyState();
  }

  return (
    <>
      <MDBTable align='middle' hover responsive>
        <MDBTableHead>
          <tr>
            <th scope='col'>Content</th>
            <th scope='col'>Status</th>
            <th scope='col'>Author</th>
            <th scope='col'>Date</th>
            <th scope='col' className="text-center">Actions</th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {messages.map((message) => (
            <tr key={message.id}>
              <td>{renderContent(message)}</td>
              <td>{getStatusBadge(message.status)}</td>
              <td>{message.author}</td>
              <td>{message.createdAt}</td>
              <td>
                <div className="d-flex justify-content-center gap-2">
                  <MDBTooltip tag='span' title="Edit Message">
                    <MDBBtn 
                      color="info" 
                      size="sm"
                      onClick={() => onEdit(message)}
                    >
                      <MDBIcon icon="edit" />
                    </MDBBtn>
                  </MDBTooltip>
                  <MDBTooltip tag='span' title="Delete Message">
                    <MDBBtn 
                      color="danger" 
                      size="sm"
                      onClick={() => onDelete(message.id)}
                    >
                      <MDBIcon icon="trash" />
                    </MDBBtn>
                  </MDBTooltip>
                </div>
              </td>
            </tr>
          ))}
        </MDBTableBody>
      </MDBTable>
      {renderPagination()}
    </>
  );
};

export default MessageTableView; 